import produce from 'immer';

import { Types, AlterarRenachSemRegistro } from './types';
import { ReducerAction } from '../../../../types';

// UTILS

export const INITIAL_STATE: AlterarRenachSemRegistro = {
	status: 0,
	data: null,
	requestData: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AlterarRenachSemRegistro {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ALTERAR_RENACH_SEM_REGISTRO_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.ALTERAR_RENACH_SEM_REGISTRO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.ALTERAR_RENACH_SEM_REGISTRO_FAILURE: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.ALTERAR_RENACH_SEM_REGISTRO_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
	});
}
